module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "menu-button",
    class: {
      'is-crossed': _vm.isPopupOpened
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    ref: "line1",
    staticClass: "icon__line line-1"
  }), _c('div', {
    ref: "line2",
    staticClass: "icon__line line-2"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5918ff9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/elements/burger.vue
// module id = 487
// module chunks = 0